<a
    mat-list-item
    [ngStyle]="{ 'padding-left': depth() * 12 + 'px' }"
    (click)="onItemSelected(item())"
    [ngClass]="{ active: routeIsActive(), expanded: expanded }"
    class="menu-list-item"
>
    <div class="menu-list-item">
        <div class="menu-list-item">
            <mat-icon class="custom">{{ item()?.iconName }}</mat-icon>
            <span class="custom">{{ item()?.displayName }}</span>
        </div>
        @if (item()?.children && item()?.children?.length) {
            <span class="custom">
                <mat-icon
                    [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'"
                >
                    expand_more
                </mat-icon>
            </span>
        }
    </div>
</a>
@if (expanded) {
    <div>
        @for (child of item()?.children; track child) {
            <app-menu-list-item [item]="child" [depth]="depth() + 1">
            </app-menu-list-item>
        }
    </div>
}
